import { getRefreshToken } from '@avanta/shared/utils/storage';
import { type ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ROUTES } from 'constants/routes';

export const PublicRoute = (): ReactElement => {
  const refreshToken = getRefreshToken();

  if (refreshToken) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return <Outlet />;
};
